var Vendd = (function (Vendd) {
    'use strict';


    var model = null;
    var pending = false;

    Vendd.MessageBus.subscribe(Vendd.FilterProduct.Messages.GetModel, Vendd.FilterProduct, function(envelope) {
        if (pending === true) {
            return false;
        };
        var configuration = JSON.parse(envelope.message.data);
        pending = true;
        function onSuccess(response) {
            model = response;

            Vendd.MessageBus.publishAsync(Vendd.FilterProduct, new Vendd.FilterProduct.Messages.Changed(model));

            pending = false;
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.FilterProduct, new Vendd.FilterProduct.Messages.Failed(response));
        }

        var queryString = location.search; 
        console.log(queryString);
        var options = {
            url: 'AdapterService.svc/GetData' + queryString + (queryString && queryString.length > 0 ? (queryString.search(/lang/i) > 0 ? '' : '&lang=' + LhApp.Context.Language) : '?lang=' + LhApp.Context.Language), 
            data: {
                serviceConfiguration: JSON.stringify(configuration)
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);

        return true;
    });

    
    

    return Vendd;

})(Vendd || {});